import { ApiGetHook, useApiGet } from "@skanska/vsa-client-auth";
import { ApiEndpoints } from "../models/ApiEndpoints";
import { TagCollection } from "../models/TagCollection";
import { FullTagCollection } from "../models/VsaaTag";

export function useTagCollectionsGet(): ApiGetHook<TagCollection[]> {
  return useApiGet<TagCollection[]>(
    ApiEndpoints.TagCollections,
    null,
    "tagcollections"
  );
}

export function useTagCollectionWithTagsGet(
  tagCollectionId: string
): ApiGetHook<FullTagCollection> {
  return useApiGet<FullTagCollection>(
    ApiEndpoints.TagCollections,
    tagCollectionId,
    `tagcollection-${tagCollectionId}`
  );
}
